import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import moment from 'moment'
import ModalCustom from '../../../components/modal-custom'
import Error_500 from '../../../components/error/error-500'
import LabelCustom from '../../../components/label-custom'
import { exportLeavesCancelAPI } from '../../../services/report/leave'
import SwalCustom from '../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../Constants'
import Error_false from '../../../components/error/error-false'
import { fnDateEn } from '../../../helper/fnDateEn'
import { FaFileAlt } from 'react-icons/fa'

const schema = yup
  .object({
    comment: yup.string().required('โปรดระบุข้อมูล')
  })
  .required()
export default function ModalCancel({
  open,
  onCancel,
  data,
  fnData,
  fnGetFile
}) {
  const [isSave, setIsSave] = useState(false)
  const {
    reset,
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  useEffect(() => {
    if (data) {
      setValue('comment', '')
    }
  }, [setValue, data])

  useEffect(() => {
    if (data) {
      setValue('endDate', moment().format('YYYY-MM-DD'))
    }
  }, [data, setValue])

  const onSubmit = async (d) => {
    try {
      setIsSave(true)
      const body = {
        leaveDetailId: data.leaveDetailId,
        comment: d.comment
      }
      const resp = await exportLeavesCancelAPI(body)
      setIsSave(false)
      if (!resp) return
      if (resp.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          onCancel()
          fnData()
          reset()
        })
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  return (
    <ModalCustom open={open} onCancel={onCancel}>
      {isSave && <div className="preloader"></div>}

      <h5 className="text-danger">ยกเลิกรายการ {data?.docNo}</h5>
      <Row className="mt-3">
        <Col xl={6}>
          <LabelCustom text="Employee" />
          <p>{data?.username}</p>
        </Col>
        <Col xl={6}>
          <LabelCustom text="Create Date	" />
          <p>{moment(data?.start_date).format('DD MMM YYYY')}</p>
        </Col>
        <Col xl={6}>
          <LabelCustom text="Leave Type	" />
          <p>{data.leaveType}</p>
        </Col>
        <Col xl={6}>
          <LabelCustom text="Time to Leave" />
          <p>{data.leaveTime}</p>
        </Col>
        <Col xl={6}>
          <LabelCustom text="Leave Date" />
          <p>
            {fnDateEn(data.startDate).format('DD/MM/YYYY')} -{' '}
            {fnDateEn(data.startDate).format('DD/MM/YYYY')}
          </p>
        </Col>
        <Col xl={6}>
          <LabelCustom text="Leave Day" />
          <p>{data.leaveDay}</p>
        </Col>
        <Col xl={6}>
          <LabelCustom text="Agent By" />
          <p>{data.agentBy ?? '-'}</p>
        </Col>
        <Col xl={6}>
          <LabelCustom text="Attach File" />
          <p>
            {data.isFile ? (
              <FaFileAlt
                className="pointer-event text-primary"
                onClick={() => fnGetFile(data.leaveDetailId)}
              />
            ) : (
              '-'
            )}
          </p>
        </Col>
        <Col xl={12}>
          <LabelCustom text="Reason" />
          <p>{data.leaveReason}</p>
        </Col>
      </Row>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col xl={12} className="mt-1">
            <LabelCustom text="Comment" />
            <Controller
              control={control}
              name="comment"
              render={({ field: { onChange, value } }) => (
                <Form.Control
                  as="textarea"
                  rows={3}
                  maxLength={250}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.comment && (
              <label className="small text-danger">
                {errors.comment.message}
              </label>
            )}
          </Col>
        </Row>

        <Row>
          <Col xl={12} className="text-end mt-4">
            <Button type="button" variant="secondary" onClick={onCancel}>
              ปิด
            </Button>
            <Button type="submit" disabled={isSave} className="px-4 ms-2">
              {isSave ? 'กำลังบันทึก...' : 'บันทึก'}
            </Button>
          </Col>
        </Row>
      </Form>
    </ModalCustom>
  )
}
